// Reads the current email list context (folder + mailbox + quick filter) from
// the #email_list turbo-frame src. Shared by the email-list and email-thread
// controllers so state-changing requests recompute counts for the active view.
export function listContext() {
  const ctx = {}
  const frame = document.getElementById("email_list")
  const src = frame?.getAttribute("src") || frame?.src
  if (!src) return ctx

  try {
    const url = new URL(src, window.location.origin)
    const folder = url.searchParams.get("folder")
    const mailboxId = url.searchParams.get("mailbox_id")
    const quickFilter = url.searchParams.get("quick_filter")
    if (folder) ctx.folder = folder
    if (mailboxId) ctx.mailbox_id = mailboxId
    if (quickFilter) ctx.quick_filter = quickFilter
  } catch (_) { /* ignore malformed src */ }

  return ctx
}
